import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t,getLanguage} from 'react-switch-lang';
import {
  getAllRiskCauses,
  createRiskCause,
  deleteRiskCause,
  updateRiskCauses,
} from '../../../services/riskCausesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './RiskCauses.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
const RiskCauses = () => {
  const [riskCauses, setRiskCauses] = useState([]);
  const [query, setQuery] = useState();
  const addButton = useRef();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRiskCauses();
        setRiskCauses(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('riskCauses.name'),
      editable: true,
      placeholder: t('riskCauses.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('riskCauses.nameEn'),
      editable: true,
      placeholder: t('riskCauses.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateRiskCauses(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('riskCauses.message.updateSuccess', {
            entity: t('riskCauses.riskCause'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.riskCausesExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.riskCausesExists')],
          },
        ]);
      }
    }
  };

  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('riskCauses.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
      </div>
      <CustomTable
        api="/risk-causes"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        queryParamName="name.contains"
        columns={columns}
        methods={{onUpdate}}
        addButtonRef={addButton}
        hideDeleteAndDeactivation={true}
      />
    </div>
  );
};

export default RiskCauses;
